import { z } from "zod/mini";

/** Transmission gear, mirrored from the truck's `drive::Gear`. */
export const GearSchema = z.enum(["neutral", "forward", "reverse"]);
export type Gear = z.infer<typeof GearSchema>;

/** The drive state the truck is currently honoring. */
export const DriveStateSchema = z.object({
	steering: z.number(),
	throttle: z.number(),
	brake: z.number(),
	gear: GearSchema,
});
export type DriveState = z.infer<typeof DriveStateSchema>;

/** A camera receive/decode/render latency component echoed by the truck. */
export const LatencyEntrySchema = z.object({
	label: z.string(),
	ms: z.number(),
});

/** Per-update telemetry the truck publishes on the `status` track. */
export const TruckStatusSchema = z.object({
	accepted: DriveStateSchema,
	mode: z.literal("render-only"),
	estopped: z.boolean(),
	driver: z.optional(z.string()),
	sequence: z.optional(z.number()),
	media_pipeline: z.record(z.string(), z.array(LatencyEntrySchema)),
	location: z.optional(z.string()),
});
export type TruckStatus = z.infer<typeof TruckStatusSchema>;
